module.exports = __webpack_public_path__ + "img/to_appleid_button.79599ad0.png";